module.exports = __webpack_public_path__ + "static/media/wasabi-bnb plp.a272c1e3.png";